import React from 'react';
import { Container } from './ui/Container';
import { Shield, Leaf, CheckCircle } from 'lucide-react';
export function MaterialsSection() {
  return <section className="py-12 bg-gray-50 border-y border-gray-200" data-id="element-244">
      <Container data-id="element-245">
        <div className="text-center mb-10" data-id="element-246">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-247">
            Safe, Comfortable, Effective
          </h2>
          <p className="text-gray-600" data-id="element-248">
            Medical-grade silicone designed for safety and comfort.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-249">
          {[{
          label: 'BPA-Free',
          icon: Shield
        }, {
          label: 'Latex-Free',
          icon: CheckCircle
        }, {
          label: 'Vegan',
          icon: Leaf
        }, {
          label: 'Non-Toxic',
          icon: Shield
        }, {
          label: 'Third-Party Tested',
          icon: CheckCircle
        }].map((badge, index) => <div key={index} className="flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-250">
              <badge.icon className="w-4 h-4 text-green-500" data-id="element-251" />
              <span className="font-semibold text-gray-700 text-sm" data-id="element-252">
                {badge.label}
              </span>
            </div>)}
        </div>
      </Container>
    </section>;
}